import { nonNull } from 'utils'

export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const deleteUnfilledFields = (row) => {
  Object.keys(row).forEach((key) => {
    // Delete unfilled fields to be properly overwritten
    if (row[key] === undefined || row[key] === '') delete row[key]
  })
}

// non-empty function for cell
export const e = (v) => nonNull(v) && v !== ''

// get value if non-empty cell
export const x = (v, defaultVal = null) => (e(v) ? v : defaultVal)
